import React, { useState, useEffect } from "react";

import { Modal, Button } from "react-bootstrap";

export default function ImportModal(props) {
  const [show, setShow] = useState(props.show);
  const [file, setFile] = useState();
  const [showAlert, setShowAlert] = useState(false);

  const handleClose = () => props.handleClose();

  const handleFileChange = (e) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  useEffect(() => {
    setShow(props.show);
  }, [props]);

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Importar {props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          {props.disabled ? (
            <div className="alert alert-info" role="alert">
              Em desenvolvimento
            </div>
          ) : (
            <>
              {showAlert ? (<>
                <div className="alert alert-warning" role="alert">
                  Somente arquivos Excel são permitidos!
                </div>
              </>) : ""}

              <h4>Informe o arquivo para realizar importação!</h4>
              <input type="file" name="file" id="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={handleFileChange} />
            </>
          )}

        </Modal.Body>
        <Modal.Footer>
          <Button variant='warning' onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            variant='primary'
            disabled={props.disabled || !file}
            onClick={() => {
              if (props.disabled) return;
              if (file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type == "application/vnd.ms-excel")
                props.callBackImport(file);
              else
                setShowAlert(true);
            }}>
            Importar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
